import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import BlogTable from './BlogTable'
import Pagination from '../Pagination'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import { useNavigate } from 'react-router-dom'
import { TextField } from '@mui/material'

function Blog () {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'blog_manager') ?? {}
  const [blog, setBlog] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [search, setSearch] = useState('')
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })

  const allBlogs = async () => {
    try {
      const payload = {
        page,
        pageSize,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
        ...(search.trim() ? { keyword: search.trim() } : {})
      }

      const path = apiPath.ListBlog
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setBlog(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  useEffect(() => {
    allBlogs()
  }, [page, sort, search])

  return (
    <div>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <form
              className='border-b border-b-[#E3E3E3] flex flex-wrap items-center justify-between gap-2 px-4 py-3'
              onSubmit={e => e.preventDefault()}
            >
              <TextField
                id='blog-search'
                label={t('O_SEARCH') || 'Search...'}
                variant='outlined'
                size='small'
                value={search}
                onChange={e => {
                  setSearch(e.target.value)
                  setPage(1)
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                    setPage(1)
                    allBlogs()
                  }
                }}
              />
              <div className='flex'>
                {(manager?.add || user?.role === 'admin') && (
                  <button
                    title={t('ADD_BLOG')}
                    type='button'
                    className='bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
                    onClick={() => {
                      navigate('/blogs/add-blog')
                    }}
                  >
                    + {t('ADD_BLOG')}
                  </button>
                )}
              </div>
            </form>
            <BlogTable
              blog={blog}
              allBlogs={allBlogs}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
              paginationObj={paginationObj}
            />
            {paginationObj?.totalItems !== 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Blog
